// extracted by css-extract-rspack-plugin
export default {"icon":"eYx9aU1bzKcv9BQB","link":"UIG2iDpHbw00dBnk"};